import { useState } from 'react';
import { BELT_SWATCHES } from '@/lib/format';

const APPAREL = [
    ['Adults Gi (incl. belt)', 107.38, 189.00],
    ['Kids Gi (incl. belt)', 100.91, 159.00],
    ['Rashguard — Short Sleeve', 29.63, 65.00],
    ['Rashguard — Long Sleeve', 29.63, 65.00],
    ['T-Shirt 230GSM Cotton (Kids & Adults)', 16.50, 45.00],
    ['Rank Belt (all colours)', 15.00, 20.00],
];

const ADULTS_SIZE_GUIDE = [
    ['A0', '155–165 cm', '55–65 kg'],
    ['A1', '160–170 cm', '65–75 kg'],
    ['A2', '168–178 cm', '75–85 kg'],
    ['A3', '175–185 cm', '85–95 kg'],
    ['A4', '183–193 cm', '95–105 kg'],
    ['A5', '190–200 cm', '105–120 kg'],
];

const KIDS_SIZE_GUIDE = [
    ['Y1 / M0000', '2–4 yrs', '90–105 cm'],
    ['Y2 / M000', '4–6 yrs', '105–115 cm'],
    ['Y3 / M00', '6–8 yrs', '115–125 cm'],
    ['Y4 / M0', '8–10 yrs', '125–135 cm'],
    ['Y5', '10–12 yrs', '135–145 cm'],
    ['Y6', '12–14 yrs', '145–155 cm'],
];

const fmt = (n) => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(n);

export default function PriceList() {
    const [w, setW] = useState(10);
    const [l, setL] = useState(10);
    const area = w * l;
    const mats = Math.ceil(area / 2);
    const matCost = mats * 85;
    const weight = mats * 9;

    return (
        <div data-testid="pricelist-page">
            <div className="font-mono-data text-xs uppercase text-crimson tracking-widest mb-2">AUD · Wholesale</div>
            <h1 className="font-display text-4xl uppercase tracking-tighter mb-3">Price List</h1>
            <p className="font-body text-zinc-400 mb-10 max-w-2xl">
                Locals Academy pricing with suggested member RRP. All prices in Australian Dollars. Embroidery included on all apparel.
            </p>

            <section className="border-hairline mb-12">
                <div className="p-5 border-b border-zinc-800 flex items-center justify-between">
                    <h2 className="font-display text-2xl uppercase tracking-tighter">Apparel</h2>
                    <span className="font-mono-data text-[10px] uppercase text-zinc-500">6–8 week lead time</span>
                </div>
                <div className="grid grid-cols-12 font-mono-data text-[10px] uppercase text-zinc-500 px-5 py-3 border-b border-zinc-800 bg-surface">
                    <div className="col-span-7">Product</div>
                    <div className="col-span-2 text-right">Your price</div>
                    <div className="col-span-2 text-right">RRP</div>
                    <div className="col-span-1 text-right">Margin</div>
                </div>
                {APPAREL.map(([name, price, rrp]) => (
                    <div key={name} className="grid grid-cols-12 px-5 py-3 border-b border-zinc-800/60 last:border-0">
                        <div className="col-span-7 font-body text-sm">{name}</div>
                        <div className="col-span-2 text-right font-mono-data text-sm">{fmt(price)}</div>
                        <div className="col-span-2 text-right font-mono-data text-sm text-zinc-400">{fmt(rrp)}</div>
                        <div className="col-span-1 text-right font-mono-data text-sm text-emerald-400">+{Math.round(((rrp - price) / price) * 100)}%</div>
                    </div>
                ))}
            </section>

            <section className="border-hairline mb-12">
                <div className="p-5 border-b border-zinc-800">
                    <h2 className="font-display text-2xl uppercase tracking-tighter">Tatami Mats</h2>
                </div>
                <div className="grid grid-cols-12 font-mono-data text-[10px] uppercase text-zinc-500 px-5 py-3 border-b border-zinc-800 bg-surface">
                    <div className="col-span-7">Product</div>
                    <div className="col-span-2 text-right">Price</div>
                    <div className="col-span-2 text-right">Coverage</div>
                    <div className="col-span-1 text-right">Weight</div>
                </div>
                <div className="grid grid-cols-12 px-5 py-3">
                    <div className="col-span-7 font-body text-sm">Tatami Mat 1×2m × 40mm — Grey No-Slip</div>
                    <div className="col-span-2 text-right font-mono-data text-sm">{fmt(85)}</div>
                    <div className="col-span-2 text-right font-mono-data text-sm">2 m²</div>
                    <div className="col-span-1 text-right font-mono-data text-sm">~9 kg</div>
                </div>
            </section>

            <section className="border-hairline mb-12 p-6">
                <h2 className="font-display text-2xl uppercase tracking-tighter mb-1">Coverage Calculator</h2>
                <p className="font-body text-sm text-zinc-400 mb-6">Enter your training area dimensions.</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="grid grid-cols-2 gap-3">
                        <label className="block">
                            <div className="font-mono-data text-[10px] uppercase text-zinc-500 mb-1">Width (m)</div>
                            <input data-testid="calc-width" type="number" min="1" value={w}
                                   onChange={(e) => setW(Math.max(1, parseInt(e.target.value || '1', 10)))}
                                   className="w-full bg-surface border border-zinc-800 px-3 py-2 font-mono-data text-white" />
                        </label>
                        <label className="block">
                            <div className="font-mono-data text-[10px] uppercase text-zinc-500 mb-1">Length (m)</div>
                            <input data-testid="calc-length" type="number" min="1" value={l}
                                   onChange={(e) => setL(Math.max(1, parseInt(e.target.value || '1', 10)))}
                                   className="w-full bg-surface border border-zinc-800 px-3 py-2 font-mono-data text-white" />
                        </label>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div className="border border-zinc-800 p-3">
                            <div className="font-mono-data text-[10px] uppercase text-zinc-500">Mats needed</div>
                            <div data-testid="calc-mats" className="font-display text-2xl">{mats}</div>
                        </div>
                        <div className="border border-zinc-800 p-3">
                            <div className="font-mono-data text-[10px] uppercase text-zinc-500">Your cost</div>
                            <div data-testid="calc-cost" className="font-display text-2xl">{fmt(matCost)}</div>
                        </div>
                        <div className="border border-zinc-800 p-3">
                            <div className="font-mono-data text-[10px] uppercase text-zinc-500">Area</div>
                            <div className="font-display text-2xl">{area} m²</div>
                        </div>
                        <div className="border border-zinc-800 p-3">
                            <div className="font-mono-data text-[10px] uppercase text-zinc-500">Total weight</div>
                            <div className="font-display text-2xl">{weight} kg</div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                <div className="border-hairline">
                    <div className="p-5 border-b border-zinc-800">
                        <h3 className="font-display text-xl uppercase tracking-tighter">Adults — Gi Size Guide</h3>
                    </div>
                    <div className="grid grid-cols-3 font-mono-data text-[10px] uppercase text-zinc-500 px-5 py-2 border-b border-zinc-800 bg-surface">
                        <div>Size</div><div>Height</div><div>Weight</div>
                    </div>
                    {ADULTS_SIZE_GUIDE.map((r) => (
                        <div key={r[0]} className="grid grid-cols-3 px-5 py-2 border-b border-zinc-800/60 last:border-0 font-mono-data text-sm">
                            <div>{r[0]}</div><div className="text-zinc-300">{r[1]}</div><div className="text-zinc-300">{r[2]}</div>
                        </div>
                    ))}
                </div>
                <div className="border-hairline">
                    <div className="p-5 border-b border-zinc-800">
                        <h3 className="font-display text-xl uppercase tracking-tighter">Kids — Gi Size Guide</h3>
                    </div>
                    <div className="grid grid-cols-3 font-mono-data text-[10px] uppercase text-zinc-500 px-5 py-2 border-b border-zinc-800 bg-surface">
                        <div>Size</div><div>Age</div><div>Height</div>
                    </div>
                    {KIDS_SIZE_GUIDE.map((r) => (
                        <div key={r[0]} className="grid grid-cols-3 px-5 py-2 border-b border-zinc-800/60 last:border-0 font-mono-data text-sm">
                            <div>{r[0]}</div><div className="text-zinc-300">{r[1]}</div><div className="text-zinc-300">{r[2]}</div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="border-hairline p-6">
                <h3 className="font-display text-2xl uppercase tracking-tighter mb-4">Belt Colours</h3>
                <div className="flex flex-wrap gap-3">
                    {BELT_SWATCHES.map((b) => (
                        <div key={b.name} className="flex items-center gap-2 px-3 py-2 border border-zinc-800 bg-surface">
                            <span className="w-6 h-6 border border-zinc-700" style={{ background: b.hex }} />
                            <span className="font-mono-data text-xs">{b.name}</span>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
